<template>
	<div class="app-intro-content">
		<div class="article__html">
			<!-- 应用名称和标题 -->
			<div class="app-intro__header">
				<h1 class="app-intro__title">大兴数字文化馆</h1>
				<p class="app-intro__subtitle">多端展示系统 - 让文化服务触手可及</p>
			</div>

			<!-- 应用介绍 -->
			<div class="app-intro__section">
				<h2 class="app-intro__section-title">应用介绍</h2>
				<p>大兴数字文化馆是北京市大兴区文化馆倾力打造的多端展示系统，基于公共用户视角，根据实际用户使用场景设计对应的用户体验及流程，实现PC端网站、移动端APP（iOS/Android/HarmonyOS）、微信小程序和微信服务号的多端多场景标准化用户互动及文化展示系统。</p>
				<p>系统致力于将文化馆从立体冰冷的建筑通过数字化技术转变成了人们手里指尖有温度、可流动的一项资源，从而顺利地渗透进公众的文化领域，打通公共文化服务"最后一公里"，使文化馆真正成为群众性的公益文化平台。</p>
			</div>

			<!-- 功能特色 -->
			<div class="app-intro__section">
				<h2 class="app-intro__section-title">功能特色</h2>
				<div class="app-intro__features">
					<div class="feature-item">
						<h3 class="feature-item__title">文化资源/资讯展示</h3>
						<p>整合大兴区公共文化数字资源，提供丰富的文化服务内容，包括文化资讯、活动信息、场馆介绍等，让用户随时随地了解文化动态。</p>
					</div>
					<div class="feature-item">
						<h3 class="feature-item__title">用户互动</h3>
						<p>支持用户评论、点赞、分享等互动功能，增强用户参与感和文化体验，打造活跃的文化社区氛围。</p>
					</div>
					<div class="feature-item">
						<h3 class="feature-item__title">积分管理兑换</h3>
						<p>完善的积分体系，用户通过参与活动、签到等方式获得积分，可用于兑换文化礼品或参与特色活动。</p>
					</div>
					<div class="feature-item">
						<h3 class="feature-item__title">精彩返场申请</h3>
						<p>用户可申请喜爱的文化活动返场，让优质文化内容得到更广泛的传播和体验。</p>
					</div>
					<div class="feature-item">
						<h3 class="feature-item__title">个人中心</h3>
						<p>个性化的用户中心，管理个人信息、收藏内容、活动报名、积分记录等，提供便捷的服务体验。</p>
					</div>
				</div>
			</div>

			<!-- 应用截图展示 -->
			<div class="app-intro__section">
				<h2 class="app-intro__section-title">应用展示</h2>
				<div class="app-intro__screenshots">
					<div class="screenshot-item" v-for="(img, index) in screenshots" :key="index">
						<img :src="img" :alt="`大兴数字文化馆应用截图${index + 1}`" class="screenshot-item__img" />
					</div>
				</div>
			</div>

			<!-- 服务信息 -->
			<div class="app-intro__section">
				<h2 class="app-intro__section-title">服务信息</h2>
				<p>大兴数字文化馆提供全方位的公共文化服务，包括：</p>
				<ul class="app-intro__service-list">
					<li>文化资源浏览与检索：提供丰富的文化资源库，支持多维度检索和浏览</li>
					<li>文化活动报名参与：在线报名各类文化活动，实时查看活动状态</li>
					<li>场馆信息查询：了解各分馆详细信息、开放时间、地址导航等</li>
					<li>在线学习与培训：提供文化课程、培训资源，支持在线学习</li>
					<li>文化圈子互动：加入文化兴趣圈子，与同好交流分享</li>
					<li>积分奖励体系：参与活动获得积分，兑换文化礼品和服务</li>
					<li>多端同步体验：PC、移动APP、小程序、服务号数据同步，随时随地享受服务</li>
				</ul>
			</div>

			<!-- 社会效益 -->
			<div class="app-intro__section">
				<h2 class="app-intro__section-title">社会效益</h2>
				<p>北京市大兴区数字文化馆建设将大幅改善现有文化服务的信息孤岛现状，发挥文化服务资源的集约效应，突破文化馆功能单一的局限性，使文化馆从立体冰冷的建筑通过数字化技术转变成了人们手里指尖有温度，可流动的一项资源，从而顺利地渗透进公众的文化领域，打通公共文化服务"最后一公里"，使文化馆真正成为群众性的公益文化平台。</p>
				<p>在全区建立起均衡发展、上下联通、服务优质、保障有力的总分馆公共文化服务体系，促进公共文化服务标准化、均等化、社会化、数字化发展。</p>
				<p>本期项目建设内容通过将大兴区公共文化数字资源整合在一个平台，丰富文化服务内容，实现资源互通互联。有粘结性的线上线下一体服务，使文化馆公共文化服务方式更加开放、即时、先进，彻底解决了大兴区文化资源分散、服务群体受限、服务渠道单一、实际到达率低等关键问题，让群众接受到更开放、先进、便捷的公众文化享受，充分享受公共文化服务的权益。</p>
			</div>

			<!-- 后端数据内容（如果有） -->
			<div v-if="curData_ && curData_.txt" class="app-intro__backend-content" v-html="curData_.txt"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				screenshots: [
					require('@/assets/img/app/1.jpg'),
					require('@/assets/img/app/2.jpg'),
					require('@/assets/img/app/3.jpg'),
					require('@/assets/img/app/4.jpg'),
					require('@/assets/img/app/5.jpg'),
					require('@/assets/img/app/6.jpg')
				]
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.app-intro-content{
		background-color: #fff;
		min-height: 500px;
	}

	.article__html{
		padding: 30px 40px 70px;
	}

	.app-intro__header{
		text-align: center;
		margin-bottom: 50px;
		padding-bottom: 30px;
		border-bottom: 2px solid #0260FE;
	}

	.app-intro__title{
		font-size: 36px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #414141;
		line-height: 50px;
		margin: 0 0 15px 0;
	}

	.app-intro__subtitle{
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
		line-height: 34px;
		margin: 0;
	}

	.app-intro__section{
		margin-bottom: 50px;

		&:last-child{
			margin-bottom: 0;
		}
	}

	.app-intro__section-title{
		font-size: 24px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #414141;
		line-height: 40px;
		margin: 0 0 25px 0;
		padding-left: 15px;
		border-left: 4px solid #0260FE;
	}

	.app-intro__section p{
		margin: 15px 0;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
		line-height: 34px;
		text-indent: 2em;
		word-break: break-all;
	}

	.app-intro__features{
		display: flex;
		flex-wrap: wrap;
		gap: 30px;
		margin-top: 25px;
	}

	.feature-item{
		flex: 1;
		min-width: 280px;
		background: #F8F9FA;
		padding: 25px;
		border-radius: 8px;
		transition: all 0.3s ease;

		&:hover{
			background: #F0F4FF;
			box-shadow: 0 4px 12px rgba(2, 96, 254, 0.1);
		}
	}

	.feature-item__title{
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #0260FE;
		line-height: 30px;
		margin: 0 0 15px 0;
	}

	.feature-item p{
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
		line-height: 28px;
		margin: 0;
		text-indent: 0;
	}

	.app-intro__screenshots{
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
		gap: 20px;
		margin-top: 25px;
	}

	.screenshot-item{
		background: #F8F9FA;
		border-radius: 8px;
		overflow: hidden;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		transition: transform 0.3s ease;

		&:hover{
			transform: translateY(-5px);
			box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
		}
	}

	.screenshot-item__img{
		width: 100%;
		height: auto;
		display: block;
		object-fit: cover;
	}

	.app-intro__service-list{
		margin: 20px 0;
		padding-left: 40px;
		
		li{
			font-size: 16px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #666666;
			line-height: 34px;
			margin: 10px 0;
			text-indent: 0;
		}
	}

	.app-intro__backend-content{
		margin-top: 50px;
		padding-top: 30px;
		border-top: 1px solid #DEDEDE;
	}
</style>
